import axios, { type AxiosInstance } from 'axios';

export const TOKEN_STORAGE_KEY = 'tavola.token';

function buildClient(): AxiosInstance {
    const instance = axios.create({
        baseURL: '/api',
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        timeout: 10_000,
    });

    instance.interceptors.request.use((config) => {
        const token = localStorage.getItem(TOKEN_STORAGE_KEY);
        if (token) {
            config.headers.set('Authorization', `Bearer ${token}`);
        }
        return config;
    });

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            // 401 → token inválido ou ausente. Limpa o token local. NÃO redirecionamos
            // mais à força (browse-first): a página decide se manda pro login ou
            // mostra "Entrar pra continuar". Páginas que exigem auth são protegidas
            // pelo route guard.
            if (error?.response?.status === 401) {
                localStorage.removeItem(TOKEN_STORAGE_KEY);
            }
            return Promise.reject(error);
        },
    );

    return instance;
}

export const api = buildClient();
